import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable, Subscription, of } from "rxjs";
import { map, max, startWith } from "rxjs/operators";
import { RouteFilterService } from "../../services/Route-Filter.service";
import { IRouteMapRequest } from "../../models/IRouteMapRequest";
import { ToastrService } from "ngx-toastr";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { EstatusJSON } from "../../../shared/models/EstatusJSON";
import { ILocationDTO } from "../../models/GeoPosLocations/IGetLastGeoJson";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { ResumeRouteMapDTO } from "../../models/ResumeRouteMapDTO";
import { StepDetailsRouteDTO } from "../../models/StepDetailsRouteDTO";
import { GroupStepRouteDTO } from "../../models/GroupStepRouteDTO";
import { RouteMapService } from "../../services/Route-Map.service";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelResumeRouteService } from "../../services/Panel-Resume-Route.service";
import { MapService } from "src/app/features/shared/services/Map.service";
import { SessionService } from "src/app/features/shared/services/Session.service";

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },

  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

interface IRequestMapRouteForm {
  vehiculo?: ILocationDTO;
  startDate: Date;
  endDate: Date;
}

@Component({
  selector: "route-filter",
  templateUrl: "./route-filter.component.html",
  styleUrls: ["./route-filter.component.css"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class RouteFilterComponent implements OnInit, OnDestroy {
  myControl = new FormControl(<string | ILocationDTO>"");
  filteredOptions: Observable<void | ILocationDTO[]>;
  itemsLocations: ILocationDTO[] = [];
  $LocationsMin: Observable<EstatusJSON>;
  isSelectTime: boolean = false;
  isLoading: boolean = false;
  formValid: boolean = false;
  private requestUrl: any;
  checkedDia: boolean = true;
  maxStartDate: Date = new Date();
  minStartDate: Date = new Date();
  isDatePickerDisabled: boolean = false;

  public request: IRequestMapRouteForm = {
    vehiculo: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  isRawRequest: boolean = false;
  rawDate: Date = new Date();
  rawStartTime: string = "00:00";
  IsAuthenticated: boolean;
  requestToken: any;
  routeMapPoints: string[];
  public geojson_routeMap: string;
  directionsAPIJson: any;
  public $ItemsGet: string[] = [];
  public $Items: string[];
  public isMapix: boolean = false;
  customer: any;

  subscription_checkAuthenticated: Subscription;
  subscription_getList: Subscription;
  subscription_findByIdentifier: Subscription;
  subscription_getRouteMapGeoJson: Subscription;
  subscription_getDirectionsAPI: Subscription;
  subscription_routeFilterService: Subscription;
  subscription_vehiculo: Subscription;
  isAdmin: boolean;
  $vehiculo: Observable<ILocationDTO> = new Observable<ILocationDTO>();

  constructor(
    private mapService: MapService,
    private toastrService: ToastrService,
    private routeFilterService: RouteFilterService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelper: MapHelperService,
    private sessionService: SessionService,
    private routeMapService: RouteMapService
  ) {
    this.isSelectTime = false;
    this.checkedDia = true;

    this.$vehiculo = this.routeFilterService.getVehiculo();
    this.subscription_vehiculo = this.$vehiculo.subscribe((element) => {
      this.request.vehiculo = element;
    });

  }

  ngOnInit(): void {
    this.getListLocationsService();
    this.request.startDate = new Date();
    this.request.endDate = new Date();
    this.rawDate = new Date();
    this.rawStartTime = "00:00";

    this.maxStartDate = new Date();
    this.minStartDate = new Date();
    this.minStartDate.setDate(this.minStartDate.getDate() - 15);

  }

  ngOnDestroy() {
    if (this.subscription_checkAuthenticated)
      this.subscription_checkAuthenticated.unsubscribe();
    if (this.subscription_getList) this.subscription_getList.unsubscribe();
    if (this.subscription_findByIdentifier)
      this.subscription_findByIdentifier.unsubscribe();
    if (this.subscription_getRouteMapGeoJson)
      this.subscription_getRouteMapGeoJson.unsubscribe();
    if (this.subscription_getDirectionsAPI)
      this.subscription_getDirectionsAPI.unsubscribe();
    if (this.subscription_routeFilterService)
      this.subscription_routeFilterService.unsubscribe();
    if (this.subscription_vehiculo)
      this.subscription_vehiculo.unsubscribe();
  }

  onClose(){
    this.routeFilterService.setVisibilityPanel(false);
  }

  checkURLSource() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  ngOnSelectTime() {
    // console.log("change checkbox");
    // this.isSelectTime = !this.isSelectTime;
    // this.request.startTime = "00:00";
    // this.request.endTime = "24:00";
    // this.formValid = !this.formValid;
  }

  onSubmit() {
    console.log("fechas inicio", this.request.startDate.toISOString());
    console.log("fechas fin", this.request.endDate.toISOString());
    console.log("hora", this.rawStartTime);
    console.log("request vehiculo", this.request.vehiculo);

    if (
      this.request.vehiculo &&
      this.request.startDate &&
      this.request.endDate
    ) {
      try {
        const startDate = new Date(this.request.startDate);
        const endDate = new Date(this.request.endDate);
        var startHour = "00:00";
        startDate.setHours(this.request.startDate.getHours() - 6);
        endDate.setHours(this.request.endDate.getHours() - 6);
        if (!this.isRawRequest)
          startHour = null;
        else
          startHour = this.rawStartTime;
        var requestRouteMap: IRouteMapRequest = {
          Identifier: this.request.vehiculo.identifier.trim(),
          StartDate: this.request.startDate.toISOString(),
          EndDate: this.request.endDate.toISOString(),
          StartHour: startHour,
        };

        console.log("updating...");

        this.getRouteMapService(requestRouteMap);
      } catch (error) {
        // this.request.startDate = null;
        console.log(error);
      }
    }
  }

  onClearForm() {
    this.request.startDate = new Date();
    this.request.endDate = new Date();
    this.rawDate = new Date();
    this.rawStartTime = "00:00";
    
    this.mapService.UpdateLayerGeoJson(
      "route-layer",
      this.mapService.Empty_GeoJson
    );
    this.mapService.UpdateLayerGeoJson(
      "points-layer",
      this.mapService.Empty_GeoJson
    );
    this.maxStartDate = new Date();
    this.minStartDate = new Date();
    this.minStartDate.setDate(this.minStartDate.getDate() - 15);
  }
  selectLocation() {
    /*this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );*/
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        const identifier = typeof value === "string" ? value : value?.identifier;
        return identifier ? this._filter(identifier as string) : this.itemsLocations.slice();
      })
    );

    console.log("filtered options", this, this.filteredOptions);
  }
  getListLocationsService() {
    this.subscription_getList = this.routeFilterService
      .getList()
      .subscribe((data) => {
        if (data.isSuccess == true) {
          this.itemsLocations = data.result;
          console.log("getListLocationsService", this.itemsLocations);
        }
      });
  }
  displayFn(value: any): string {
    return value && value.identifier ? value.identifier : "";
  }

  onFindLocation(event) {
    var texto = event.target.value;
    if (texto.length == 0) {
      // this.filteredOptions = this.myControl.valueChanges.pipe(
      //   startWith(""),
      //   map((value) => this._filter(value))
      // );
      console.log("reset filter...");
      console.log("filtered options", this.filteredOptions);
    } else {
      if (texto.length > 2) {
        this.subscription_findByIdentifier = this.routeFilterService
          .findByIdentifier(texto)
          .subscribe((arg) => {
            if (texto.length == 17) {
              this.request.vehiculo = arg.result[0];
              this.routeFilterService.setVehiculo( arg.result[0]);
            }
            this.filteredOptions = of(arg.result);
            console.log("buscando...");
            console.log("filtered options", this.filteredOptions);
          });
      }
    }
  }

  onOptionSelected(){
    this.isDatePickerDisabled = false;
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {
    this.isLoading = true;

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe(
      (resp) => {
        console.log(resp);
        this.isLoading = false;
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            if (resumeRoute.cantStops != "0" && resp.result.groupStepsRouteDTO != null) {
              this.routeMapService.showRouteMapLayers();
              this.updateComponentResume(
                resumeRoute,
                detailsRoute,
                groupedRoute,
                routeMapRequest
              );
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              this.toastrService.info(
                "Sin Resultados",
                "El VIN seleccionado no contiene información en ese rango de fechas"
              );
            }
          } else {
            this.toastrService.info(
              "Sin Resultados",
              "El VIN seleccionado no contiene información en ese rango de fechas"
            );
          }
        } else {
          // this.toastrService.error("Internal Error", elements.errors.toString());
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }
  updateComponentResume(
    resumeRoute: ResumeRouteMapDTO,
    detailsRoute: StepDetailsRouteDTO[],
    groupedRoute: GroupStepRouteDTO[],
    request: IRouteMapRequest
  ) {
    this.panelResumeRouteService.setVisibilityPopup(true);
    
    this.panelResumeRouteService.setResume(resumeRoute);
    this.panelResumeRouteService.setDetails(detailsRoute);
    this.panelResumeRouteService.setGrouped(groupedRoute);
    console.log("groupedRoute", groupedRoute);
    this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
    //this.panelResumeRouteService.setRequest(request);
  }

  private _filter(value: string): ILocationDTO[] {
    const filterValue = value.toUpperCase().toString();

    return this.itemsLocations.filter((option) =>
      option.identifier.toUpperCase().includes(filterValue)
    );
  }

  limteFecha(event: MatDatepickerInputEvent<Date>) {
    if (event.value == null) {
      this.maxStartDate = null;
    } else {
      //si se llega a requerir que haya más de 15 días, usar este
      // const start = new Date(event.value).getTime();
      // const addedDays = 15 * 24 * 60 * 60 * 1000;
      // const end = new Date(start + addedDays);
      // this.maxEndDate = end;
      // this.minEndDate = new Date(event.value);
    }
  }

  onDateChange(event: any): void {
    this.request.startDate = this.rawDate;
    console.log("rawDate", this.rawDate, this.request.startDate);
    
  }

  setRawRequest() {
    this.isRawRequest = !this.isRawRequest;
  }
}
